let currentZoom = {
  actual: getZoom(),
  last: null
};
var resizeTimer;

function getZoom() {
  return Math.round(window.devicePixelRatio * 100);
}

function changeCurrentZoom() {
  if (getZoom() != currentZoom.actual) {
      currentZoom.last = currentZoom.actual;
      currentZoom.actual = getZoom();
  }
  let eventWindowZoom = new CustomEvent('tc-theme-window-zoom');
  document.dispatchEvent(eventWindowZoom);
}

window.onresize = function (e) {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(changeCurrentZoom, 100);
};

export default currentZoom;
